(function () {
  'use strict';

  var buttonSelector = [
    '.dd-product-card__wishlist.swym-button',
    '.dd-collection-card__wishlist.swym-button'
  ].join(', ');

  function toKey(value) {
    return value === null || value === undefined || value === '' ? '' : String(value);
  }

  function getButtons() {
    return Array.prototype.slice.call(document.querySelectorAll(buttonSelector));
  }

  function getButtonKeys(button) {
    return [
      button.getAttribute('data-variant-id'),
      button.getAttribute('data-product-id')
    ].map(toKey).filter(Boolean);
  }

  function getItems(payload) {
    if (Array.isArray(payload)) return payload;
    if (payload && Array.isArray(payload.items)) return payload.items;
    if (payload && Array.isArray(payload.products)) return payload.products;
    return null;
  }

  function getItemKeys(item) {
    if (!item || typeof item !== 'object') return [];

    return [
      item.variant_id,
      item.variantId,
      item.epi,
      item.product_id,
      item.productId,
      item.empi,
      item.id
    ].map(toKey).filter(Boolean);
  }

  function applyState(payload) {
    var items = getItems(payload);
    if (!items) return;

    var keys = new Set();

    items.forEach(function (item) {
      getItemKeys(item).forEach(function (key) {
        keys.add(key);
      });
    });

    getButtons().forEach(function (button) {
      var buttonKeys = getButtonKeys(button);
      var isAdded = buttonKeys.some(function (key) {
        return keys.has(key);
      });

      button.classList.toggle('dd-wishlist-is-added', isAdded);
      button.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
    });
  }

  function fetchState() {
    if (!window._swat || typeof window._swat.fetch !== 'function') return false;

    window._swat.fetch(function (payload) {
      applyState(payload);
    });

    return true;
  }

  function scheduleFetch() {
    [150, 500, 1200].forEach(function (delay) {
      window.setTimeout(fetchState, delay);
    });
  }

  function waitForSwym(attempt) {
    if (fetchState() || attempt >= 40) return;
    window.setTimeout(function () {
      waitForSwym(attempt + 1);
    }, 250);
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest && event.target.closest(buttonSelector)) {
        scheduleFetch();
      }
    },
    true
  );

  var mutationTimer;
  var observer = new MutationObserver(function () {
    window.clearTimeout(mutationTimer);
    mutationTimer = window.setTimeout(fetchState, 100);
  });

  function start() {
    waitForSwym(0);

    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    waitForSwym(0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
